import type { SpikeReceivedItem } from '@personal-os/shared';

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}

function show(value: unknown): string | null {
  if (value === null || value === undefined || value === '') return null;
  return typeof value === 'string' ? value : JSON.stringify(value);
}

/** Finds a field whatever its capitalisation ("Amount", "amount", "Card or Pass"). */
function pick(record: Record<string, unknown>, ...names: string[]): string | null {
  for (const [key, value] of Object.entries(record)) {
    const k = key.toLowerCase();
    if (names.some((n) => k === n || k.startsWith(n))) {
      const shown = show(value);
      if (shown) return shown;
    }
  }
  return null;
}

/** One readable line for the Received list. The raw data is always available too. */
export function summarize(item: SpikeReceivedItem): string {
  const p = asRecord(item.payload);
  switch (item.kind) {
    case 'share':
      return (
        [show(p.title), show(p.url) ?? show(p.text)].filter(Boolean).join(' · ') || 'Empty share'
      );
    case 'note':
      return show(p.text) ?? 'Empty note';
    case 'wallet': {
      const parts = [pick(p, 'amount'), pick(p, 'merchant', 'name'), pick(p, 'card')].filter(
        Boolean,
      );
      return parts.length > 0 ? parts.join(' · ') : 'Received, but no amount, merchant or card';
    }
    case 'push_sent':
      return `Notification accepted by the push service (HTTP ${show(p.status) ?? '?'})`;
    case 'push_error':
      return `Notification failed (HTTP ${show(p.status) ?? '?'})${p.removed === true ? ' · phone unsubscribed' : ''}`;
  }
}
